/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CategoryShowCategoryResponse } from './CategoryShowCategoryResponse';

export type CategoryShowCategoryResponseApiRespoonse = {
    data?: CategoryShowCategoryResponse;
    status?: CategoryShowCategoryResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace CategoryShowCategoryResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

